import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import CreateIcon from "@mui/icons-material/Create";
import { default as Button } from "../../../../components/common/button/Button";
import ProfileBanner from "./images/Profile_Banner_Pro.png";
import USFlag from "./images/USFlag.png";
import CanadaFlag from "./images/CanadaFlag.png";
import { EditContentModal } from "./components/EditContentModal";
import { getUserProfileData, Logout } from "../../../../api/UserController";
import Typography from "../../../../components/common/text/Typography";
import { getWindowSize, formatDateTimeWithTimeZone } from "../../../../utils/generalUtils";
import { setColor } from "../../../../assets/styles/styles";
import FadeCard from "./components/FadeCard";
import Modal from "../../components/Modal";
import UserIcon from "../../../../assets/images/icons/UC_Features_Account_PFP_Green.png";
import InfoIcon from "../../../../assets/images/icons/UC_Sprite_Icon_System_Info.png";
import SpotifyIcon from "../../../../assets/images/icons/UC_Sprite_Logo_Partners_Spotify_Icon.png";
import UnlinkIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Unlink.png";
import ActiveStatus from "../../../../assets/images/icons/Active.svg";
import InactiveStatus from "../../../../assets/images/icons/Inactive.svg";
import LocationIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Location.png";
import BirthdayIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Birthday.png";
import PhoneIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Phone.png";
import Wave from "../../../../assets/images/graphics/UC_Graphic_Wave.png";
import CountrySplashArt from "../../../../assets/videos/splasharts/v1_splashart_anim_country_v1.mp4";
import MailIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Email.png";
import PasswordIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Password.png";
import { fetchSpotify } from "../../../../redux/slices/spotify";
import { getProfile, getSpotifyToken, handleSpotifyAuth } from "../../../../features/spotify/api/SpotifyController";
import { SaveSpotify } from "../../../../redux/actions/SpotifyActions";
import { setToSessionStorage } from "../../../../hooks/useSessionStorage";
import LinkIcon from "../../../../assets/images/icons/UC_Sprite_Icon_Link.png";

const Profile = () => {
    const dispatch = useDispatch();
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [editEmailModal, setEditEmailModal] = useState(false);
    const [editPassModal, setEditPassModal] = useState(false);
    const [editBirthdayModal, setEditBirthdayModal] = useState(false);
    const [editDetailsModal, setEditDetailsModal] = useState(false);
    const [contactSupportModal, setContactSupportModal] = useState(false);
    const [requestProModal, setRequestProModal] = useState(false);
    const [exitConsoleModal, setExitConsoleModal] = useState(false);
    const [disconnectAppModal, setDisconnectAppModal] = useState(false);
    const [externalAppType, setExternalAppType] = useState("");
    const [birthday, setBirthday] = useState(null);
    const [joinedDate, setJoinedDate] = useState(null);

    // User Details states
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [country, setCountry] = useState("");
    const [username, setUsername] = useState("");
    const [isProTier, setIsProTier] = useState(false);
    // const [phoneNumber, setPhoneNumber] = useState('');

    const token = useSelector((state) => state?.user?.token);
    const userId = useSelector((state) => state?.user?.userId);
    const userEmail = useSelector((state) => state?.user?.email);
    const role = useSelector((state) => state?.user?.role).toUpperCase();

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const spotify = useSelector(fetchSpotify);

    const handleClose = () => {
        setEditEmailModal(false);
        setEditPassModal(false);
        setEditBirthdayModal(false);
        setEditDetailsModal(false);
    };

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    const handleLogout = async () => {
        await Logout(dispatch);
    };

    const handleProtier = () => {
        setIsProTier(true); // this function is for future use where user has a pro tier
    };

    useEffect(() => {
        const handlePageLoad = async () => {
            try {
                const userData = await getUserProfileData(token, userId);
                if (userData && userData.data) {
                    const { userBirthday, displayName, firstName, lastName, userCountry, createdAt } = userData.data;
                    if (userBirthday) {
                        const [yyyy, mm, dd] = userBirthday.split("-").map(Number);
                        const monthNames = [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                        ];
                        const formattedDate = `${monthNames[mm - 1]} ${dd}, ${yyyy}`;
                        setBirthday(formattedDate);
                    } else {
                        setBirthday(null);
                    }
                    if (createdAt) setJoinedDate(formatDateTimeWithTimeZone(createdAt));
                    if (displayName) setUsername(displayName);
                    if (firstName) setFirstName(firstName);
                    if (lastName) setLastName(lastName);
                    if (userCountry) setCountry(userCountry);
                } else {
                    console.error("User data is missing.");
                }
            } catch (error) {
                console.error("Error fetching user profile data:", error);
            }
        };
        handlePageLoad();
    }, [
        birthday,
        username,
        firstName,
        lastName,
        country,
        editBirthdayModal,
        editDetailsModal,
        editEmailModal,
        editPassModal,
        token,
        userId,
    ]);

    /// for Spotify login
    useEffect(() => {
        const existingScript = document.querySelector(`script[src="https://sdk.scdn.co/spotify-player.js"]`);

        if (!existingScript) {
            const script = document.createElement("script");
            script.src = "https://sdk.scdn.co/spotify-player.js";
            script.async = true;
            document.body.appendChild(script);

            window.onSpotifyWebPlaybackSDKReady = () => {};
        }

        if (code) {
            getSpotifyToken(code, urlParams, process.env.REACT_APP_WEB_URL).then((res) => {
                if (res?.accessToken) {
                    getProfile(res.accessToken).then((profile) => {
                        // Grabs profile and check if account is premium
                        if (profile.product === "free") {
                            // props.setSpotifyNotPremiumAccount(true);
                            return;
                        }

                        if (profile.product === "premium") {
                            setToSessionStorage("spotifyAccessToken", res.accessToken);
                            setToSessionStorage("spotifyRefreshToken", res.refreshToken);

                            dispatch(SaveSpotify(res.accessToken, res.refreshToken));
                        }
                    });
                }
            });
        }
    }, []);

    return (
        <>
            {/* <BannerContainer windowSize={windowSize}>
                <ColumnContentContainer>
                    <RowContentContainer>
                        <img src={usernameIcon} alt="usernameIcon" />
                        <Typography
                            variant="h1UserHeader"
                            fontSize="46px"
                            style={{ color: setColor.accent4, margin: "1rem 0rem" }}
                        >
                            {username}
                        </Typography>
                    </RowContentContainer>
                    {country !== "" && country !== null && country !== undefined && (
                        <Typography variant="UsernameText">
                            <img
                                style={
                                    country === "Canada" ? { height: "35px", width: "35px", marginTop: "3px" } : null
                                }
                                src={country === "Canada" ? CanadaFlag : USFlag}
                                alt="US Flag"
                            />
                            {country}
                        </Typography>
                    )}
                </ColumnContentContainer>
            </BannerContainer> */}
            {/* <UserConsoleText style={{ marginTop: "2rem" }}>General Details</UserConsoleText> */}
            <GridWrapper>
                <StickySidebar>
                    <ColoredContainer>
                        <UserIconContainer src={UserIcon} alt="User Icon" />
                        <ColumnContentContainer>
                            <Typography variant="UsernameText" margin={"5px"} fontSize={"30px"}>
                                {/* <img src={usernameIcon} alt="usernameIcon" style={{ marginRight: "8px" }} /> */}
                                {username}
                            </Typography>

                            <Typography variant="pWhite" margin={"0px 0px 20px 0px"} fontSize={"17px"}>
                                {firstName} {lastName}
                            </Typography>
                            <UserInfoContainer>
                                <Typography variant="pWhite" margin={"5px 0px 10px 0px;"} fontSize={"17px"}>
                                    <IconContainer
                                        src={BirthdayIcon}
                                        alt="birthday icon"
                                        height={"20px"}
                                        width={"20px"}
                                        style={{ marginRight: "10px" }}
                                    />
                                    {birthday || "N/A"}
                                </Typography>

                                <Typography variant="pWhite" margin={"0px 0px 10px 0px;"} fontSize={"17px"}>
                                    <IconContainer
                                        src={PhoneIcon}
                                        alt="phone icon"
                                        height={"20px"}
                                        width={"20px"}
                                        style={{ marginRight: "10px" }}
                                    />
                                    {"N/A"}
                                </Typography>

                                <Typography
                                    variant="pWhite"
                                    align={"left"}
                                    margin={"0px 0px 5px 0px;"}
                                    fontSize={"17px"}
                                >
                                    <IconContainer
                                        src={LocationIcon}
                                        alt="location icon"
                                        height={"20px"}
                                        width={"20px"}
                                        style={{ marginRight: "10px" }}
                                    />
                                    {country || "N/A"}
                                </Typography>
                            </UserInfoContainer>
                            <Button
                                variant={"PurpleButton"}
                                label="Edit Profile"
                                backgroundColor={setColor.brightVioletTransparent10}
                                buttonWidth={"85%"}
                                buttonMobileWidth={"95%"}
                                // margin="0"
                                onClick={() => {
                                    setEditDetailsModal(true);
                                }}
                                boxShadow="none"
                            >
                                Edit Profile
                            </Button>
                        </ColumnContentContainer>
                        <WaveImage src={Wave} alt="wave" />
                    </ColoredContainer>
                </StickySidebar>
                <MainContent>
                    <SplashArtContainer playsInline controls={false} autoPlay muted loop>
                        <source src={CountrySplashArt} type="video/mp4" />
                        Your browser does not support the video tag.
                    </SplashArtContainer>
                    {/* <UserConsoleText>Birthday</UserConsoleText>
                    <SmallSubtitle>
                        Let Intraverse know your birthday! We may send you a gift or exclusive offers and deals on your
                        special day!
                    </SmallSubtitle>
                    {birthday === null || birthday === undefined ? (
                        <Button
                            variant="PinkButton"
                            label="ADD MY BIRTHDAY"
                            buttonWidth={120}
                            margin={"1rem 0rem 2rem 0rem"}
                            onClick={() => {
                                setEditBirthdayModal(true);
                            }}
                        />
                    ) : (
                        <InputContainer>
                            <img
                                src={birthdayIcon}
                                alt="birthdayIcon"
                                style={{
                                    margin: "5px",
                                    color: setColor.iconColor3,
                                    cursor: "default",
                                    height: "20px",
                                    width: "20px",
                                }}
                            />
                            <Input
                                onClick={() => {
                                    setEditBirthdayModal(true);
                                }}
                                type="text"
                                placeholder={birthday}
                            />
                            <CreateIcon
                                onClick={() => {
                                    setEditBirthdayModal(true);
                                }}
                                sx={{ "&:hover": { color: setColor.iconColor3 }, margin: "5px", color: "grey" }}
                            />
                        </InputContainer>
                    )} */}
                    {/* <BorderContainer> */}
                    <FadeCard>
                        <Card>
                            <AccountContentWrapper>
                                <LeftContent>
                                    <UserConsoleText>Account</UserConsoleText>

                                    <FlexRow>
                                        <SmallSubtitle>
                                            {!isProTier ? (
                                                <>
                                                    <strong>Live Tier</strong> (Free)
                                                </>
                                            ) : (
                                                <>
                                                    <strong>Pro tier</strong> (Premium)
                                                </>
                                            )}
                                        </SmallSubtitle>

                                        <InfoIconWrapper>
                                            <InfoIconContainer src={InfoIcon} alt="Info Icon" />

                                            <Tooltip>
                                                {isProTier ? (
                                                    <>
                                                        Enjoy your premium Pro features. For help, contact{" "}
                                                        <span
                                                            style={{
                                                                color: setColor.spanTextColorThree,
                                                                fontWeight: "700",
                                                            }}
                                                        >
                                                            support@terrazero.com
                                                        </span>
                                                        .
                                                    </>
                                                ) : (
                                                    "You're on a free account. Upgrade to pro for premium benefits!"
                                                )}
                                            </Tooltip>
                                        </InfoIconWrapper>
                                        <Divisor hasDivisor />

                                        <ResponsiveSubtitleWrapper>
                                            <SmallSubtitle>
                                                {joinedDate !== null ? <>Intraverse user since {joinedDate}</> : ""}
                                            </SmallSubtitle>
                                        </ResponsiveSubtitleWrapper>
                                    </FlexRow>
                                </LeftContent>
                                <ButtonWrapper>
                                    <Button
                                        label="Request Pro"
                                        variant="PurpleButton"
                                        margin={"0px 0px 0px 0px"}
                                        onClick={() => {
                                            setRequestProModal(true);
                                        }}
                                        backgroundColor={setColor.brightVioletTransparent10}
                                        boxShadow="none"
                                    />
                                </ButtonWrapper>
                            </AccountContentWrapper>
                        </Card>
                    </FadeCard>
                    <FadeCard>
                        <Card>
                            <PaddedContainer>
                                <UserConsoleText>Login Information</UserConsoleText>
                                <SmallSubtitle>
                                    The information below is what you currently use to log in Intraverse.
                                </SmallSubtitle>
                                <RowContentContainer>
                                    <InputContainer flex={"1"}>
                                        <IconContainer
                                            src={MailIcon}
                                            alt="mail icon"
                                            height={"20px"}
                                            width={"20px"}
                                            style={{ margin: "5px" }}
                                        />
                                        <Input
                                            style={{ pointerEvents: "none" }}
                                            readOnly
                                            type="email"
                                            placeholder={userEmail}
                                            value={userEmail}
                                        />
                                        {/* <CreateIcon
                                            // onClick={() => {
                                            //     setEditEmailModal(true); to allow edit email, undo this comment
                                            // }}
                                            sx={{
                                                "&:hover": { color: setColor.iconColor3 },
                                                margin: "5px",
                                                color: "grey",
                                            }}
                                        /> */}
                                    </InputContainer>

                                    <InputContainer flex={"1"}>
                                        <IconContainer
                                            src={PasswordIcon}
                                            alt="password icon"
                                            height={"20px"}
                                            width={"20px"}
                                            style={{ margin: "5px" }}
                                        />
                                        <Input
                                            style={{ pointerEvents: "none" }}
                                            readOnly
                                            // type="password"
                                            placeholder="*********"
                                        />
                                        <CreateIcon
                                            onClick={() => {
                                                setEditPassModal(true);
                                            }}
                                            sx={{
                                                "&:hover": { color: setColor.iconColor3 },
                                                margin: "5px",
                                                color: "grey",
                                            }}
                                        />
                                    </InputContainer>
                                </RowContentContainer>
                            </PaddedContainer>
                        </Card>
                    </FadeCard>

                    <FadeCard>
                        <Card>
                            <PaddedContainer>
                                <UserConsoleText>Apps</UserConsoleText>
                                <SmallSubtitle>Connect to external apps and upgrade your experiences</SmallSubtitle>
                                <ExternalAppContainer>
                                    <InputContainer>
                                        <LogoTextWrapper>
                                            <IconContainer src={SpotifyIcon} alt="spotify" />
                                            <Typography variant="h3Custom" fontSize={"19px"} fontWeight={"900"}>
                                                Spotify
                                            </Typography>
                                        </LogoTextWrapper>
                                        <IconContainer
                                            src={spotify.token ? ActiveStatus : InactiveStatus}
                                            alt="Spotify Status"
                                            height={"9px"}
                                            width={"9px"}
                                            style={{ marginRight: "10px" }}
                                            // display={!}
                                        />
                                        <IconContainer
                                            onClick={() => {
                                                // if (spotify.token) {
                                                //     handleDisconnectSpotify();
                                                // } else {
                                                //     handleSpotifyAuth(process.env.REACT_APP_WEB_URL);
                                                // }
                                                setExternalAppType("Spotify");
                                                if (spotify.token) {
                                                    setDisconnectAppModal(true);
                                                } else {
                                                    setExitConsoleModal(true);
                                                }
                                            }}
                                            // disabled={spotify.token}
                                            src={spotify.token ? UnlinkIcon : LinkIcon}
                                            alt={spotify.token ? "Unlink Spotify" : "Link Spotify"}
                                        />
                                    </InputContainer>
                                </ExternalAppContainer>
                            </PaddedContainer>
                        </Card>
                    </FadeCard>

                    <FadeCard>
                        <Card>
                            <PaddedContainer>
                                <RowContainer>
                                    <AccountTextContainer>
                                        <UserConsoleText>Account Removal</UserConsoleText>
                                        <SmallSubtitle>
                                            Contact our support team to temporarily disable or{" "}
                                            <strong>permanently</strong> delete your account.
                                        </SmallSubtitle>
                                    </AccountTextContainer>
                                    <Button
                                        label="Support"
                                        variant="PurpleButton"
                                        // buttonWidth={"20%"}
                                        margin="0"
                                        backgroundColor={setColor.brightVioletTransparent10}
                                        onClick={() => {
                                            setContactSupportModal(true);
                                        }}
                                        boxShadow="none"
                                    />
                                </RowContainer>
                            </PaddedContainer>
                        </Card>
                    </FadeCard>
                </MainContent>
            </GridWrapper>
            <Modal
                isOpen={editEmailModal}
                setIsOpen={setEditEmailModal}
                children={
                    <EditContentModal open={editEmailModal} userEmail={userEmail} isEmail handleClose={handleClose} />
                }
            />
            <Modal
                isOpen={editPassModal}
                setIsOpen={setEditPassModal}
                children={<EditContentModal open={editPassModal} isPassword handleClose={handleClose} />}
            />
            <Modal
                isOpen={editBirthdayModal}
                setIsOpen={setEditBirthdayModal}
                children={
                    <EditContentModal
                        open={editBirthdayModal}
                        isBirthday
                        handleClose={handleClose}
                        setCurrentBirthday={setBirthday}
                    />
                }
            />
            <Modal
                isOpen={editDetailsModal}
                setIsOpen={setEditDetailsModal}
                children={
                    <EditContentModal
                        open={editDetailsModal}
                        isUserData
                        handleClose={handleClose}
                        setCurrentBirthday={setBirthday}
                    />
                }
            />

            <Modal
                isOpen={contactSupportModal}
                setIsOpen={setContactSupportModal}
                children={<EditContentModal open={editDetailsModal} isContactSupport handleClose={handleClose} />}
            />

            <Modal
                isOpen={requestProModal}
                setIsOpen={setRequestProModal}
                children={<EditContentModal open={editDetailsModal} isRequestPro handleClose={handleClose} />}
            />

            <Modal
                isOpen={exitConsoleModal}
                setIsOpen={setExitConsoleModal}
                children={
                    <EditContentModal
                        open={editDetailsModal}
                        isExitConsole
                        externalAppType={externalAppType}
                        handleClose={handleClose}
                    />
                }
            />

            <Modal
                isOpen={disconnectAppModal}
                setIsOpen={setDisconnectAppModal}
                children={
                    <EditContentModal
                        open={editDetailsModal}
                        isDisconnectApp
                        externalAppType={externalAppType}
                        handleClose={handleClose}
                    />
                }
            />
        </>
    );
};

export default Profile;

const BannerContainer = styled.div`
    display: flex;
    background-image: url(${ProfileBanner});
    background-size: 100% 95%;
    background-repeat: no-repeat;
    max-width: 1280px;
    height: auto;
    padding: 1rem 4rem 4rem 4rem;
    align-items: center;
    justify-content: center;
    margin-left: -33px;
    margin-right: -33px;

    & img {
        margin-right: 1rem;
    }

    @media (max-width: 768px) {
        background-size: cover;
    }
`;

const AccountContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 100%;
    padding: 20px 30px;
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`;

const ButtonWrapper = styled.div`
    margin-left: auto;

    @media (max-width: 768px) {
        margin-left: 0;
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
    }
`;
const PaddedContainer = styled.div`
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
`;

const RowContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    margin-top: 20px;

    @media (max-width: 768px) {
        flex-direction: column;

        & img {
            margin-left: 3rem;
        }
    }
`;
const ColumnContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px 0;
    margin-bottom: auto;
`;

const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: 30% 70%;
    max-width: 100%;
    height: auto;
    // padding: 1rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0rem;
        padding: 0rem;
    }
`;
const ColoredContainer = styled.div`
    border-radius: 10px;
    border: 1px solid rgba(190, 174, 255, 0.1);
    width: 100%;
    height: auto;
    min-height: calc(90vh - 60px);
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        padding: 0.5rem;
        text-align: center;
        min-height: auto;
    }
`;

const StickySidebar = styled(ColoredContainer)`
    margin-top: 30px;
    position: sticky;
    top: 1rem;
    align-self: start;
    height: calc(90vh - 60px);
    max-width: 324px;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        position: relative;
        top: unset;
        width: 100%;
        grid-column: span 2;
        height: auto;
        max-width: 100%;
        padding: 0;
        box-sizing: border-box;
    }
`;

const MainContent = styled.div`
    margin-top: 30px;
    margin-bottom: 25px;
    padding-right: 6px;

    @media (max-height: 1200px) {
        margin-bottom: 10px;
    }

    @media (max-width: 768px) {
        margin-top: 0px;
        padding: 0;
    }
`;

const UserInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    border-radius: 10px;
    background: ${setColor.brightVioletTransparent10};
    margin-bottom: 10px;
    height: auto;
    width: 85%;
    padding: 20px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 95%;
        padding: 10px;
        margin-bottom: 20px;
    }
`;

const UserIconContainer = styled.img`
    margin: 60px auto 10px auto;
    width: 150px;
    height: 150px;
    border-radius: 10%;
    background: ${setColor.accent4};
    cursor: pointer;
`;

const Card = styled.div`
    display: flex;
    flex-direction: column;
    background: ${setColor.opaquePurple};
    border-radius: 14px;
    padding: 1rem;
    gap: 30px;
    border: 1px solid ${setColor.brightVioletTransparent};
    max-width: 946px;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    height: auto;
    box-sizing: border-box;

    @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
        padding: 0;
    }
`;

const AccountTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    flex: 1 0 0;
`;

const RowContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
`;

const Input = styled.input`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    border: none;
    background: transparent;
    width: 90%;
    height: 50px;
    color: white;
    margin-left: 8px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px transparent inset !important;
        -webkit-text-fill-color: white !important;
    }
`;
const InputContainer = styled.div`
    display: flex;
    flex: ${(props) => (props.flex ? props.flex : "0 0 auto")};
    margin-right: 8px;
    border-radius: 10px;
    justify-content: center;
    background: transparent;
    cursor: pointer;
    height: 50px;
    align-items: center;
    padding: 5px;
    border: 1px solid ${setColor.brightVioletTransparent};

    &:hover {
        background: ${setColor.brightVioletTransparent10};
    }

    @media (max-width: 768px) {
        margin: 5px;
        width: 100%;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        margin: 5px;
        width: 100%;
    }
`;

const SmallSubtitle = styled.p`
    text-align: left;
    color: ${setColor.circularProgress};
    font-family: "Barlow", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0px;

    & > span {
        color: ${setColor.iconColor3};
        font-weight: 700;
    }
`;

const ResponsiveSubtitleWrapper = styled.div`
    @media (max-width: 768px) {
        display: block;
        text-align: left;
        white-space: normal;
        width: 100%;
    }
`;

const LeftContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const FlexRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 10px;

    @media (max-width: 768px) {
        align-items: flex-start;
        gap: 5px;
    }
`;

const UserConsoleText = styled.h1`
    color: ${setColor.circularProgress};
    font-family: "Barlow", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0px;
    margin-bottom: 5px;
`;

const Tooltip = styled.div`
    position: absolute;
    top: -60%;
    left: 600%;
    transform: translateX(-50%);
    background-color: black;
    color: white;
    width: 200px;
    height: auto;
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-family: "Barlow", sans-serif;
    text-align: left;
    white-space: normal;
    visibility: hidden;
    opacity: 0;
    z-index: 9999;
    transition: opacity 0.2s ease-in-out;

    &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

const InfoIconWrapper = styled.div`
    position: relative;
    display: inline-block;

    &:hover ${Tooltip} {
        visibility: visible;
        opacity: 1;
    }
`;

const InfoIconContainer = styled.img`
    width: 16px;
    height: 16px;
    margin-top: 5px;
    cursor: pointer;
    position: relative;

    &:hover {
        opacity: 0.8;
    }

    @media (max-width: 768px) {
        margin: 2px 0px 0px 5px;
    }
`;

const Divisor = styled.div`
    width: 1px;
    height: 30px;
    background-color: ${setColor.brightVioletTransparent};
    margin-bottom: 10px;

    &::before {
        content: ${(props) => (props.hasDivisor ? '""' : "none")};
        position: absolute;
        left: -17px;
        width: 2px;
        height: 80%;
    }

    @media (max-width: 1100px) {
        display: none;
        margin-bottom: 0px;
    }
`;

const ExternalAppContainer = styled.div`
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
    height: auto;
    width: 100%;
    min-width: 700px;
    box-sizing: border-box;
    margin-top: 20px;
    flex-direction: column;
    gap: 10px;

    @media (max-width: 1300px) {
        min-width: auto;
        width: 100%;
    }
`;

const IconContainer = styled.img`
    width: ${(props) => (props.width ? props.width : "30px")};
    height: ${(props) => (props.height ? props.height : "30px")};
    display: ${(props) => (props.display ? "none" : "")};
    pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const ContextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 1rem;
`;

const LogoTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-grow: 1;
    padding-left: 10px;
`;

const ActiveLinkWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-left: 20px;
`;

const SplashArtContainer = styled.video`
    width: 100%;
    max-height: 360px;
    object-fit: cover;
    border-radius: 10px;

    @media (max-width: 768px) {
        display: none;
    }
`;

const WaveImage = styled.img`
    // object-fit: cover;
    width: 100%;
    height: 90%;
    margin-top: 20%;

    @media (max-height: 1080px) {
        height: 30%;
        margin-top: 0;
    }

    @media (max-height: 900px) {
        height: 24%;
        width: 70%;
        margin-left: 30%;
        margin-top: 0;
    }

    @media (max-height: 820px) {
        display: none;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;
